
    <template>
      <section class="relax-doc">
        <h1>Badge 徽标</h1>
<blockquote>
<p>用于按钮、图标旁的数字或状态标记。</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>用于表示状态的小圆点。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-badge status=&quot;success&quot; /&gt;
  &lt;x-badge status=&quot;error&quot; /&gt;
  &lt;x-badge status=&quot;default&quot; /&gt;
  &lt;x-badge status=&quot;warning&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge status=&quot;success&quot; text=&quot;success&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge status=&quot;error&quot; text=&quot;error&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge status=&quot;default&quot; text=&quot;default&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge status=&quot;warning&quot; text=&quot;warning&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="shan-yao"><a class="header-anchor" href="#shan-yao"></a> 闪耀</h2>
<blockquote>
<p>添加<code>shine</code>，开启闪耀徽标</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-badge shine status=&quot;success&quot; /&gt;
  &lt;x-badge shine status=&quot;error&quot; /&gt;
  &lt;x-badge shine status=&quot;default&quot; /&gt;
  &lt;x-badge shine status=&quot;warning&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge shine status=&quot;success&quot; text=&quot;success&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge shine status=&quot;error&quot; text=&quot;error&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge shine status=&quot;default&quot; text=&quot;default&quot; /&gt;
  &lt;br /&gt;
  &lt;x-badge shine status=&quot;warning&quot; text=&quot;warning&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="du-li-shi-yong"><a class="header-anchor" href="#du-li-shi-yong"></a> 独立使用</h2>
<blockquote>
<p>不包裹任何元素独立使用</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-badge count=&quot;24&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_badge = _resolveComponent("x-badge")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_badge, { status: "success" }),
    _createVNode(_component_x_badge, { status: "error" }),
    _createVNode(_component_x_badge, { status: "default" }),
    _createVNode(_component_x_badge, { status: "warning" }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      status: "success",
      text: "success"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      status: "error",
      text: "error"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      status: "default",
      text: "default"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      status: "warning",
      text: "warning"
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_badge = _resolveComponent("x-badge")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_badge, {
      shine: "",
      status: "success"
    }),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "error"
    }),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "default"
    }),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "warning"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "success",
      text: "success"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "error",
      text: "error"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "default",
      text: "default"
    }),
    _createElementVNode("br"),
    _createVNode(_component_x_badge, {
      shine: "",
      status: "warning",
      text: "warning"
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_badge = _resolveComponent("x-badge")

  return (_openBlock(), _createBlock(_component_x_badge, { count: "24" }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  